module.exports = __webpack_public_path__ + "static/media/date-2.643abd3b.jpg";